import { LitElement, html, css } from "lit";

export class MyPageMenu extends LitElement {
  static properties = {
    cols: { type: Number },
  };

  static styles = css`
    :host {
      width: 100%;
    }

    .menu__container {
      margin-inline: auto;
      //margin-top: 80px;
      padding-bottom: 30px;
      width: 100%;
      max-width: 1140px; 
      display: flex;
      justify-content: space-between;
    }
    .menu__items {
      display: grid;
      flex-wrap: wrap;
      gap: 30px;
      width: 100%;
      grid-template-columns: var(--mypage__menu__items-grid-template-columns, repeat(2, 1fr));
      grid-auto-rows: 1fr;
      @media(max-width: 768px) {
        display: flex;
        gap: 20px;
        grid-template-columns: var(--mypage__menu__items-grid-template-columns_mobile, 1fr);
        padding-inline: 15px;
      }
    }
    /* @container (width < 1140px) {
      .menu__container {
        max-width: 1140px;
      }
    } */
  `;

  constructor() {
    super();
    this.cols = 2;
  }

  render () {
    this.style.setProperty("--mypage__menu__items-grid-template-columns", `repeat(${this.cols}, 1fr)`);
    return html`
      <div class="menu__container">
        <div class="menu__items">
          <slot></slot>
        </div>
      </div>`;
  }
}

export class MyPageMenuItem extends LitElement {
  static properties = {
    visible: {},
    icon: {},
    href: {},
    target: {},
    title: {},
    text: {},
    type: {},
  };

  // static get styles() {
  //   return styles;
  // }

  static styles = css`
    :host {
      --local-page-color: var(--minside__page__color, var(--primary__color-500));
      display: contents;
      height: min-content;
      @media only screen and (max-width: 75em) {
        margin-inline: 15px;
      }
    }

    .material-icons-outlined,
    .material-symbols-outlined {
      font-family: 'Material Icons Outlined';
      font-weight: normal;
      font-style: normal;
      font-size: 24px;
      line-height: 1;
      letter-spacing: normal;
      text-transform: none;
      display: inline-block;
      white-space: nowrap;
      word-wrap: normal;
      direction: ltr;
      -webkit-font-smoothing: antialiased;
    }

    .material-symbols-outlined {
      font-family: 'Material Symbols Outlined';
    }

    /* .header__container {
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
    } */

    .menuitem {
      // flex: var(--mypage__menuitem-flex, 0  0 48.68%);
      display: flex;
      justify-content: flex-end;
      width: 100%;
      & .external__icon {
        position: absolute;
        margin-top: 16px;
        margin-right: 16px;
        opacity: .7;
      }
    }

    .menuitem__link {
      background: var(--minside__menu__item_bg, #ffffff);
      border: 6px solid var(--minside__menu__item_bg, #ffffff);
      border-radius: var(--minside__menu__item_border-radius, 6px);
      color: var(--fullnav__main__link_color,#333);
      display: flex;
      width: -webkit-fill-available;
      margin-bottom: 0!important;
      padding: 14px 24px;
      text-decoration: none;
      transition: all .25s;
      @media(max-width: 768px) {
        padding: 20px;
      }
    }

    .menuitem__link:hover {
      color: var(--fullnav__main__link_color,#333);
      text-decoration: none;
      box-shadow: 2px 2px 4px 0px #00000040;
    }
    
    .menuitem__content {
      display: flex;
      flex-direction: column;
      min-height: fit-content;
      margin-top: 4px;
      /* align-items: center;
      justify-content: space-between; */
      /* max-height: 121px;
      height: 121px; */
    }

    .menuitem__icon {
      align-items: center;
      background-color: var(--minside__menu__icon_bg, color-mix(in srgb, var(--local-page-color), #fff 70%));
      border-radius: 50%;
      display: flex;
      justify-content: center;
      font-size: 3.125rem;
      font-weight: 300;
      height: 82px;
      min-width: 82px;
      margin-right: 20px;
      transition: all 0.3s ease 0s;
      @media(max-width: 768px) {
        font-size: 2rem;
        height: 44px;
        min-width: 44px;
      }
    }
    
    .menuitem-logo {
      max-height: 70px;
      max-width: 180px;
    }
    span.menuitem__icon {
      margin-right: 0;
      background-color: transparent;
    }

    .menuitem__link:hover div.menuitem__icon {
      background-color: var(--minside__menu__icon_bg_hover, color-mix(in srgb, var(--local-page-color), #fff 20%));
    }

    .menuitem__title {
      font-size: 1.5rem;
      margin: 0;
      @media(max-width: 768px) {
        font-size: 1.25rem;
      }
    }

    .menuitem__link:hover .menuitem__title {
      text-decoration: underline;
    }
    .menuitem__text {
      font-size: 1.125rem;
      margin: 0;
      padding-top: 4px;
      @media(max-width: 768px) {
        font-size: 1.1rem;
      }
    }
    .justify-center {
      justify-content: center;
    }
    .text-center {
      align-items: center;
      justify-content: space-between;
      & .menuitem__title {
        font-size: 24px;
        font-weight: 400;
      }
    }
  `;

  constructor() {
    super();
    this.icon = "home";
    this.href = "#";
    this.target = "_self";
    this.title = "Tittel";
    this.text = "Tekst";
  }

  render () {
    if (this.visible === "true" || this.visible === undefined) {
      const type = this.type;
      const showDescription = type !== "external-services";
      const showIconAboveTitle = type === "external-services";
      const isExternalURL = checkLinkType(this.href) === "external";

      return html`
        <div class="menuitem">
          ${isExternalURL ? html`<span class="material-icons-outlined external__icon">open_in_new</span>` : ""}
          <a href="${this.href}" target="${this.target}" class="menuitem__link ${showIconAboveTitle ? "justify-center" : ""}">
            ${!showIconAboveTitle ? html`<div class="material-symbols-outlined menuitem__icon"><span class="material-symbols-outlined menuitem__icon">${this.icon}</span></div>` : ""}
            <div class="menuitem__content${showIconAboveTitle ? " text-center" : ""}">
              ${showIconAboveTitle ? html`<img class='menuitem-logo' src='${this.icon}' alt='${this.title}' />` : ""}
              <h2 class="menuitem__title">${this.title}</h2>
              ${showDescription ? html`<p class="menuitem__text">${this.text}</p>` : ""}
            </div>
          </a>
        </div>
        `;
    }
    return html``;
  }
}

customElements.define("mypage-menu", MyPageMenu);
customElements.define("mypage-menuitem", MyPageMenuItem);

function checkLinkType (url) {
  const link = document.createElement("a");
  link.href = url;

  if (link.hostname === window.location.hostname) {
    if (link.pathname.startsWith("/")) {
      return "local";
    }
    return "relative";
  }
  return "external";
}
